import { useState } from "react";
import { apiFetch } from "../api";
import { theme } from "../theme";
import RankioLogo from "../components/RankioLogo";
import ExpiredScreen from "./ExpiredScreen";

// ── Login ──────────────────────────────────────────────────────────────────────
export default function LoginScreen({ onLogin }) {
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [expired, setExpired] = useState(false);

  const handleLogin = async () => {
    if (!token.trim()) { setError("Zadej licenční token."); return; }
    setLoading(true); setError("");
    try {
      const data = await apiFetch("/me", token.trim());
      onLogin(token.trim(), data);
    } catch (e) {
      const msg = e.message || "";
      if (msg.includes("403") || msg.includes("vypršela") || msg.includes("expired")) {
        setExpired(true);
      } else if (msg.includes("401")) {
        setError("Neplatný token.");
      } else {
        setError("Chyba připojení k serveru. (" + msg + ")");
      }
    }
    setLoading(false);
  };

  if (expired) return <ExpiredScreen onBack={() => setExpired(false)} />;

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(135deg, ${theme.blueSoft} 0%, #fff 55%, #eef3ff 100%)`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: theme.font, padding: 24,
    }}>
      <div className="fadeUp" style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
            <RankioLogo height={44} />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: theme.ink, marginBottom: 6 }}>Přihlásit se</h1>
          <p style={{ color: theme.inkSoft, fontSize: 14 }}>Zadej svůj licenční token</p>
        </div>

        <div style={{
          background: theme.bg, borderRadius: theme.rCard, padding: 32,
          boxShadow: theme.shadowMd,
          border: `1px solid ${theme.line}`,
        }}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: theme.inkSoft, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>
            Licenční token
          </label>
          <input
            value={token}
            onChange={e => setToken(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleLogin()}
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            style={{
              width: "100%", boxSizing: "border-box",
              border: "1.5px solid " + (error ? theme.badLine : theme.line),
              borderRadius: 10, padding: "11px 14px", fontSize: 13,
              fontFamily: theme.font, fontVariantNumeric: theme.tnum, color: theme.ink,
              background: theme.bgSoft, marginBottom: error ? 8 : 16,
            }}
            onFocus={e => e.target.style.borderColor = theme.blue}
            onBlur={e => e.target.style.borderColor = error ? theme.badLine : theme.line}
          />
          {error && <p style={{ color: theme.bad, fontSize: 13, marginBottom: 14 }}>{error}</p>}
          <button onClick={handleLogin} disabled={loading} style={{
            width: "100%", padding: "13px",
            background: `linear-gradient(135deg, ${theme.blue}, ${theme.blueDark})`,
            border: "none", borderRadius: theme.rBtn, color: "#fff",
            fontSize: 15, fontWeight: 700,
            boxShadow: "0 4px 16px #126DFB30",
            fontFamily: theme.font,
            opacity: loading ? 0.7 : 1,
          }}>
            {loading ? "Ověřuji…" : "Přihlásit se →"}
          </button>
        </div>

        <p style={{ textAlign: "center", color: theme.mut, fontSize: 13, marginTop: 20 }}>
          Nemáš přístup?{" "}
          <a href="mailto:info@rankio.cz" style={{ color: theme.blue, textDecoration: "none", fontWeight: 600 }}>
            Kontaktuj podporu
          </a>
        </p>
      </div>
    </div>
  );
}
